import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxExport,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTitle,
  DxSubtitle,
  DxTooltip,
} from 'devextreme-vue/chart';
import DxSelectBox from 'devextreme-vue/select-box';


/* Example dataSource: [{"argumentField":"2/2022","value":189},
{"argumentField":"3/2022","value":26.3},
{"argumentField":"4/2022","value":265},
{"argumentField":"1/2023","value":31.41}]

plotData: [{"value":"value","name":"Consumption"}]
*/ 
export default {
  name: "DxLineChart",
  props: {
    dataSource: {
      type: Array,
      required: true,
    },
    plotData: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    chartType: {
      type: String,
      default:'line'
    },
    enableExport: {
      type: Boolean,
      default: false
    },
  },
  components: {
    DxSelectBox,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxExport,
    DxGrid,
    DxMargin,
    DxLegend,
    DxTitle,
    DxSubtitle,
    DxTooltip,
  },

  data() {
    return {
      energySources: [
        { value: 'hydro', name: 'Hydro-electric' },
       
      ],
      types: ['line', 'stackedline', 'fullstackedline'],
      type: 'line',
    };
  },
};
